// Sdílené pomocné funkce pro kalendář (Calendar, sloupcový graf, výběr data na kartě firmy).

// Stav aktivity, který v kalendáři rezervuje 2 hodiny (schůzka u zákazníka).
export const MEETING_STATUS = 'Schůzka domluvena';
// Všechny stavy, které se v kalendáři berou jako naplánovaná schůzka.
export const MEETING_STATUSES = ['Schůzka domluvena', 'Naplánovaná schůzka'];
export const MEETING_DURATION_HOURS = 2;

// Je daný stav firmy naplánovaná schůzka?
export function isMeetingStatus(status) {
  return MEETING_STATUSES.includes(status);
}

// Lokální klíč dne 'YYYY-MM-DD'
export function toDayKey(date) {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function isSameLocalDay(a, b) {
  const da = new Date(a);
  const db = new Date(b);
  return da.getFullYear() === db.getFullYear()
    && da.getMonth() === db.getMonth()
    && da.getDate() === db.getDate();
}

// Má uživatel s daným datem narození narozeniny v daný den? (bez ohledu na rok)
export function isBirthdayOn(birthDate, day) {
  if (!birthDate) return false;
  const bd = new Date(birthDate);
  const d = new Date(day);
  return bd.getMonth() === d.getMonth() && bd.getDate() === d.getDate();
}

// Kolik let uživatel v daný den slaví (může být null pokud rok narození není smysluplný)
export function ageOn(birthDate, day) {
  if (!birthDate) return null;
  const bd = new Date(birthDate);
  const d = new Date(day);
  let age = d.getFullYear() - bd.getFullYear();
  return age > 0 && age < 130 ? age : null;
}

// Pondělní začátek týdne pro daný den
export function startOfWeekMonday(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const day = (d.getDay() + 6) % 7; // Po=0 ... Ne=6
  d.setDate(d.getDate() - day);
  return d;
}

// Mřížka měsíce (6 týdnů = 42 dní), začíná pondělím
export function monthGridDays(anchor) {
  const first = new Date(anchor.getFullYear(), anchor.getMonth(), 1);
  const start = startOfWeekMonday(first);
  const days = [];
  for (let i = 0; i < 42; i++) {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    days.push(d);
  }
  return days;
}

export const CZ_DAY_NAMES = ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'];
export const CZ_MONTH_NAMES = [
  'Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen',
  'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'
];
